import React, { FC } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { captureEvent } from './services/event-capture';
import captureSpecificError from './services/capture-error';

const handleError = (error: unknown, errorInfo: unknown) => {
  try {
    captureSpecificError(
      error,
      'containers/app-main-client/src/app.jsx',
      {
        errorInfo: errorInfo as string,
      },
      {
        deckeeId: '[error boundary] handle error',
      },
    );
  } catch (e: unknown) {
    // eslint-disable-next-line no-console
    console.error('Could not log error', e);
  }

  try {
    captureEvent({
      type: 'app: error',
      payload: {
        error: (error as Error)?.message || 'no message',
        errorInfo,
      },
    });
  } catch (e: unknown) {
    // eslint-disable-next-line no-console
    console.error('Could not log error to Amplitude', e);
  }
  // eslint-disable-next-line no-console
  console.error(error, errorInfo);
};

const AppErrorBoundary: FC<{ children: React.ReactNode }> = ({ children }) => (
  <ErrorBoundary fallbackRender={() => <></>} onError={handleError}>
    {children}
  </ErrorBoundary>
);

export default AppErrorBoundary;
